var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPasswordEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#21241E",
  d: "M15.582 12a3.58 3.58 0 1 1-7.16 0 3.58 3.58 0 0 1 7.16 0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#21241E",
  d: "M12 20.27c3.53 0 6.82-2.08 9.11-5.68a5.33 5.33 0 0 0 0-5.19C18.815 5.8 15.53 3.72 12 3.72S5.18 5.8 2.89 9.4a5.33 5.33 0 0 0 0 5.19c2.29 3.6 5.58 5.68 9.11 5.68Z"
})));
export { SvgPasswordEye as ReactComponent };
export default __webpack_public_path__ + "e709b8fdb7ee5229b6631e3fc8ff59ee.svg";